import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import packageInfo from '../../../package.json';

const Footer = (props) => {
  const location = useLocation();

  return (
    <React.Fragment>
      {location.pathname !== '/calls/manage' && (
        <footer className="footer">
          <Container fluid={true}>
            <Row className="pb-3">
              <Col md={6}>
                {new Date().getFullYear()} © Sos Dottore -{' '}
                <a
                  href="/privacy-policy.html"
                  target="_blank"
                  rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                ,{' '}
                <a
                  href="https://www.iubenda.com/privacy-policy/21991191/cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer">
                  Cookie Policy
                </a>{' '}
                e{' '}
                <a
                  href="https://www.iubenda.com/termini-e-condizioni/21991191"
                  target="_blank"
                  rel="noopener noreferrer">
                  Termini e Condizioni
                </a>
              </Col>
              <Col md={6}>
                <div className="text-sm-right d-none d-sm-block">
                  Design & Develop with{' '}
                  <i className="mdi mdi-heart text-danger"></i> by SosDottore.it
                  - v{packageInfo.version}
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      )}
    </React.Fragment>
  );
};

export default Footer;
